/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creation_Actions_AriaInputs */

const en_creation_actions_aria = /** @type {(inputs: Creation_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open creation actions`)
};

const pt_br2_creation_actions_aria = /** @type {(inputs: Creation_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir ações de criação`)
};

/**
* | output |
* | --- |
* | "Open creation actions" |
*
* @param {Creation_Actions_AriaInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const creation_actions_aria = /** @type {((inputs?: Creation_Actions_AriaInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creation_Actions_AriaInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creation_actions_aria(inputs)
	return pt_br2_creation_actions_aria(inputs)
});